import axios from "axios";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import * as Yup from "yup";
import { default as logoDark, default as logoLight } from "../../assets/images/Aditya.png";



const backendUrl = process.env.REACT_APP_BACKEND_URL;

const VerifyOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const roll_no = location?.state?.roll_no || "";

  document.title = "Verify OTP | Forget Password";

  /** FORM VALIDATION */
  const validation = useFormik({
    initialValues: {
      roll_no: roll_no,
      otp: "",
    },
    validationSchema: Yup.object({
      otp: Yup.string()
        .required("OTP is required")
        .length(6, "OTP must be 6 digits"),
    }),
    onSubmit: async (values) => {
      await handleVerify(values);
    },
  });

  /** VERIFY OTP API */
  const handleVerify = async (values) => {
    try {
      const response = await axios.post(`${backendUrl}validate-otp`, {
        roll_no: values.roll_no,
        otp: values.otp,
      });

      alert("OTP verified successfully!");

      navigate("/forgot-password", {
        state: { roll_no: values.roll_no },
      });
    } catch (err) {
      console.error("OTP Verification Failed:", err);
      alert("Invalid OTP or something went wrong!");
    }
  };

  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="overflow-hidden">
              <CardBody className="pt-0">
                <h3 className="text-center mt-5 mb-4">
                  <Link to="/" className="d-block auth-logo">
                    <img src={logoDark} alt="" height="30" className="auth-logo-dark" />
                    <img src={logoLight} alt="" height="30" className="auth-logo-light" />
                  </Link>
                </h3>

                <div className="p-3">
                  <h4 className="text-muted font-size-18 mb-3 text-center">
                    Verify OTP
                  </h4>

                  <form className="form-horizontal mt-4" onSubmit={validation.handleSubmit}>
                    <div className="mb-3">
                      <Label htmlFor="roll_no">Employee Id</Label>
                      <Input
                        name="roll_no"
                        placeholder="Enter Employee Id"
                        type="text"
                        readOnly
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.roll_no}
                        invalid={
                          validation.touched.roll_no &&
                            validation.errors.roll_no
                            ? true
                            : false
                        }
                      />
                      {validation.touched.roll_no &&
                        validation.errors.roll_no && (
                          <FormFeedback type="invalid">
                            {validation.errors.roll_no}
                          </FormFeedback>
                        )}
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="otp">OTP</Label>
                      <Input
                        name="otp"
                        placeholder="Enter OTP"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.otp}
                        invalid={
                          validation.touched.otp && validation.errors.otp
                            ? true
                            : false
                        }
                      />
                      {validation.touched.otp &&
                        validation.errors.otp && (
                          <FormFeedback type="invalid">
                            {validation.errors.otp}
                          </FormFeedback>
                        )}
                    </div>

                    <Row className="mb-3">
                      <div className="col-12 text-end">
                        <button className="btn btn-primary w-md" type="submit">
                          Verify OTP
                        </button>
                      </div>
                    </Row>
                  </form>
                </div>
              </CardBody>
            </Card>

            <div className="mt-5 text-center">
              <p>
                Wrong number?{" "}
                <Link to="/send-otp" className="text-primary">
                  Try Again
                </Link>
              </p>
            </div>

          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VerifyOtp;
